/**
 * Generate a UUID with fallback for browser compatibility
 */
export function generateUUID(): string {
  // Check if crypto.randomUUID is available
  if (typeof crypto !== 'undefined' && typeof (crypto as Crypto).randomUUID === 'function') {
    return (crypto as Crypto).randomUUID();
  }

  // Prefer cryptographically strong fallback if available
  if (typeof crypto !== 'undefined' && typeof (crypto as Crypto).getRandomValues === 'function') {
    const bytes = new Uint8Array(16);
    (crypto as Crypto).getRandomValues(bytes);
    // RFC 4122 version 4
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant
    const toHex = (n: number) => n.toString(16).padStart(2, '0');
    return (
      toHex(bytes[0]) + toHex(bytes[1]) + toHex(bytes[2]) + toHex(bytes[3]) + '-' +
      toHex(bytes[4]) + toHex(bytes[5]) + '-' +
      toHex(bytes[6]) + toHex(bytes[7]) + '-' +
      toHex(bytes[8]) + toHex(bytes[9]) + '-' +
      toHex(bytes[10]) + toHex(bytes[11]) + toHex(bytes[12]) + toHex(bytes[13]) + toHex(bytes[14]) + toHex(bytes[15])
    );
  }

  // Last-resort Math.random fallback
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

